
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ScrollArea } from '@/components/ui/scroll-area';
import { 
  BookOpen, MessageSquare, Mail, FileText, FileCheck, 
  Fingerprint, Rocket, HelpCircle, Palette
} from 'lucide-react';

export const DocumentationTabs = () => {
  return (
    <ScrollArea className="w-full mb-4">
      <TabsList className="bg-gray-800/50 border-gray-700 w-full overflow-x-auto max-w-full justify-start">
        <TabsTrigger value="intro" className="flex items-center gap-2">
          <BookOpen className="h-4 w-4" />
          <span>Einführung</span>
        </TabsTrigger>
        <TabsTrigger value="branding" className="flex items-center gap-2">
          <Palette className="h-4 w-4" />
          <span>Corporate Branding</span>
        </TabsTrigger>
        <TabsTrigger value="prompting" className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4" />
          <span>Prompting</span>
        </TabsTrigger>
        <TabsTrigger value="templates" className="flex items-center gap-2">
          <Mail className="h-4 w-4" />
          <span>E-Mail-Vorlagen</span>
        </TabsTrigger>
        <TabsTrigger value="documents" className="flex items-center gap-2">
          <FileText className="h-4 w-4" />
          <span>Versicherungsdokumente</span>
        </TabsTrigger>
        <TabsTrigger value="offers" className="flex items-center gap-2">
          <FileCheck className="h-4 w-4" />
          <span>Angebotserstellung</span>
        </TabsTrigger>
        <TabsTrigger value="signature" className="flex items-center gap-2">
          <Fingerprint className="h-4 w-4" />
          <span>Signatur</span>
        </TabsTrigger>
        <TabsTrigger value="roadmap" className="flex items-center gap-2">
          <Rocket className="h-4 w-4" />
          <span>Roadmap</span>
        </TabsTrigger>
        <TabsTrigger value="faq" className="flex items-center gap-2">
          <HelpCircle className="h-4 w-4" />
          <span>FAQ</span>
        </TabsTrigger>
      </TabsList>
    </ScrollArea>
  );
};
